import { isValid, format } from "date-fns";
import { DailyTask, Milestone } from "../../types/goals";
import TaskItem from "./TaskItem";

interface TasksTabContentProps {
    dailyTasks: DailyTask[];
    milestones: Milestone[];
    selectedMilestone: string | null;
    setSelectedMilestone: (value: string | null) => void;
    dateFilter: string;
    setDateFilter: (value: string) => void;
}
const TasksTabContent = ({
    dailyTasks,
    milestones,
    selectedMilestone,
    setSelectedMilestone,
    dateFilter,
    setDateFilter,
}: TasksTabContentProps) => {
    const filteredTasks = dailyTasks.filter(task => {
        const matchesMilestone = selectedMilestone ? task.milestoneId === selectedMilestone : true;
        const matchesDate = dateFilter
            ? isValid(task.date) && format(task.date, 'yyyy-MM-dd') === dateFilter
            : true;
        return matchesMilestone && matchesDate;
    });

    return (
        <div className="space-y-6">
            {/* Filtros */}
            <div className="flex space-x-4 mb-4">
                <select
                    value={selectedMilestone || ''}
                    onChange={(e) => setSelectedMilestone(e.target.value || null)}
                    className="flex-1 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 px-3 py-2 text-sm"
                >
                    <option value="">Todos los hitos</option>
                    {milestones.map((milestone) => (
                        <option key={milestone._id} value={milestone._id}>
                            {milestone.title}
                        </option>
                    ))}
                </select>
            </div>
            {/* Lista de tareas */}
            <div className="space-y-4">
                {filteredTasks.map(task => (
                    <TaskItem key={task._id} task={task} milestones={milestones} />
                ))}
            </div>
        </div>
    );
};

export default TasksTabContent;